
import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import SearchResultEntity from "../../../../domain/entities/search_result.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAResumeEntity from "../../../../domain/entities/qa_resume.entity";
import QAResumeDto from "../../../dto/qa_resume.dto";

const searchCallsApiImpl = async (_: {
    start_date?: string;
    end_date?: string;
    page_number: number;
    page_size: number;
    call_state?: string;
    sentiment?: string;
    audio_name?: string;
    human_agent_id?: string;
    human_agent_name?: string;
  }): Promise<Either<ErrorEntity, SearchResultEntity<QAResumeEntity>>> => {
      try {
        let relativeUrl = `/stats?page_number=${_.page_number}&page_size=${_.page_size}`;
        if (_.start_date) relativeUrl += `&start_date=${_.start_date}`;
        if (_.end_date) relativeUrl += `&end_date=${_.end_date}`;
        if (_.call_state) relativeUrl += `&call_state=${_.call_state}`;
        if (_.sentiment) relativeUrl += `&sentiment=${_.sentiment}`;
        if (_.audio_name) relativeUrl += `&audio_name=${_.audio_name}`;
        if (_.human_agent_id) relativeUrl += `&human_agent_id=${_.human_agent_id}`;
        if (_.human_agent_name) relativeUrl += `&name=${_.human_agent_name}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        // const parsed: QAResumeEntity[] = [];
        const parsed = response.content.map((item: any) => QAResumeDto.fromJSON(item));
        return right({
            data: parsed,
            itemsPerPage: _.page_size,
            page: _.page_number,
            pages: response.total_pages,
            total: response.total_elements,
          });
        } catch (e) {
        return left({ code: "Error" });
    }
}

export default searchCallsApiImpl;
